import notify from '@/plugins/notify';

import { ITimeoutState } from './Timeout-types';
import api from '../../helpers/api';

const timeoutState: ITimeoutState = {
    state: {

    },
    mutations: {

    },
    actions: {
        async sendTimeoutRequest({ dispatch }, gameId: number) {
            const response = await api.request(`/game/${gameId}/timeout`, 'POST', { gameId });

            if (response.ok) {
                dispatch('closeModal', 'timeout');
            } else {
                const error = await response.json();

                notify({
                    group: 'app',
                    title: 'Error',
                    type: 'error',
                    text: error.message,
                });
            }
        },
    },
};

export default timeoutState;
